import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './styles/CancellationControls.css';
import reportWebVitals from './reportWebVitals';

// Web-only and development-only: partner definitions and the presentation
// control are not loaded by the desktop app or a production web build.
const BrandPreview = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./theme/BrandPreview')) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {BrandPreview && <React.Suspense fallback={null}><BrandPreview/></React.Suspense>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
